module.exports = __webpack_public_path__ + "img/24-7-protection.86e1e830.svg";